"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSemVer = void 0;
const assertString_1 = require("./util/assertString");
const multilineRegex_1 = require("./util/multilineRegex");
/**
 * Regular Expression to match
 * semantic versioning (SemVer)
 * built from multi-line, multi-parts regexp
 * Reference: https://semver.org/
 */
const semanticVersioningRegex = (0, multilineRegex_1.multilineRegexp)([
    '^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)',
    '(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))',
    '?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$',
], 'i');
function isSemVer(str) {
    (0, assertString_1.assertString)(str);
    return semanticVersioningRegex.test(str);
}
exports.isSemVer = isSemVer;
